var example = {
    init: function() {
        var self = this;

        //console.log( 'example' );
    }
}

export {
    example
};
